import React, { useRef } from "react";
import { X, Printer } from "lucide-react";
import QRCode from "react-qr-code";
import "../Common/ModalCloseButton.css";
import "../../styles/QRModal.css"; // add this (see CSS below)

const QRModal = ({ isOpen, onClose, url, showPrintButton = false }) => {
  const qrRef = useRef();

  if (!isOpen) return null;

  const size = 800;            // larger QR => larger safe logo
  const LOGO_RATIO = 0.31;     // try 0.30, test; drop to 0.25 if scans fail
  const logoWidth = size * LOGO_RATIO;

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print QR Code</title>
          <style>
            body {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              margin: 0;
              background: white;
            }
            .qr-container {
              text-align: center;
            }
            .qr-title {
              font-family: Arial, sans-serif;
              font-size: 24px;
              margin-bottom: 20px;
              color: #333;
            }
            @media print {
              body {
                background: white;
              }
            }
          </style>
        </head>
        <body>
          <div class="qr-container">
            <div class="qr-title">Scan QR Code to Download Photos</div>
            ${qrRef.current.innerHTML}
          </div>
          <script>
            window.onload = function() {
              window.print();
              window.close();
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="qr-modal-code">
          <div className="qr-wrapper" style={{ width: size, height: size }} ref={qrRef}>
            <QRCode
              value={url}
              size={size}
              level="H"
              style={{ width: "100%", height: "100%" }}
            />
            <img
              src="/images/dat_logo_wh.png"
              alt="Drive A Tank"
              className="qr-logo"
              style={{ width: logoWidth, height: "auto" }}
            />
          </div>
        </div>

        {showPrintButton && (
          <div className="qr-modal-actions">
            <button className="btn btn-primary" onClick={handlePrint}>
              <Printer size={16} /> Print QR Code
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRModal;